export enum PaymentStatus {
  CANCELLED = "CANCELLED",
  CAPTURABLE = "CAPTURABLE",
  DISPUTED = "DISPUTED",
  FAILED = "FAILED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  PENDING = "PENDING",
  REFUNDED = "REFUNDED",
  SUCCESSFUL = "SUCCESSFUL",
}
